import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-survey",
  "use": "icon-survey-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-survey\">\n  <path d=\"M10.6667 0.666748H5.33333V3.33341H10.6667V0.666748Z\" fill=\"currentColor\" />\n  <path d=\"M2 2.00008H4V4.66675H12V2.00008H14V15.3334H2V2.00008ZM10 8.66675V7.33342H6V8.66675H10ZM10 11.3334V10.0001H6V11.3334H10Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol